import './js/commons/app/copyright.js';
import './vendor/Ext.ux.RadioGroup.js';
import './vendor/Ext.ux.form.LovCombo.js';
import './vendor/Ext.ux.grid.RowActions.js';
import './vendor/Ext.ux.grid.CellActions.js';
import './vendor/Ext.ux.grid.Search.js';
import './vendor/Ext.ux.grid.GridSummary.js';
import './vendor/Ext.ux.ThemeCombo.js';
import './vendor/Ext.ux.form.DateTime.js';
import './vendor/Ext.ux.form.SuperBoxSelect.js';
import './vendor/Ext.form.FileUploadField.js';
import './vendor/Ext.grid.SmartCheckboxSelectionModel.js';
import './vendor/Ext.grid.RowExpander.js';
import './vendor/Ext.grid.GroupSummary.js';
import './vendor/Ext.grid.CheckColumn.js';
import './vendor/Ext.layout.RowLayout.js';
import './vendor/Ext.ux.layout.ColumnFitLayout.js';
import './vendor/Ext.ux.form.Spinner.js';
import './vendor/Ext.ux.RemoteCheckboxGroup.js';
import './vendor/Ext.ux.plugins.IconCombo.js';
import './vendor/Ext.ux.plugins.MultiLineHeader.js';
import './vendor/Ext.ux.plugins.CollapsedPanelTitle.js';
import './vendor/Ext.ux.DDView.js';
import './vendor/Ext.ux.Multiselect.js';
import './vendor/Ext.ux.GridPrinter.js';
import './vendor/Ext.ux.IFrameComponent.js';
import './vendor/Ext.ux.ResizableButtonComponent.js';
import './vendor/Ext.ux.event.Broadcast.js';
import './vendor/Ext.Spotlight.js';
import './vendor/Ext.ux.window.MessageWindow.js';
// utils -->
import './js/commons/util/compat.js';
import './js/commons/util/util.js';
import './js/commons/util/cookies.js';
import './js/commons/util/alerts.js';
import './js/commons/util/server-events.js';
import './js/commons/util/notifications.js';
import './js/commons/util/connection.js';

// template -->
import './js/commons/tpl/lang/formatter.js';
import './js/commons/tpl/lang/us_formatter.js';
import './js/commons/tpl/lang/uk_formatter.js';
import './js/commons/tpl/lang/ru_formatter.js';
// plugins -->
import './js/commons/plugin/navigable.js';
import './js/commons/plugin/datetime.validation.js';
import './js/commons/plugin/constraint.js';
import './js/commons/plugin/dependent.js';
import './js/commons/plugin/grid.dependent.js';
import './js/commons/plugin/selectable.js';
import './js/commons/plugin/gridfilter.js';
import './js/commons/plugin/tab.initializable.js';
import './js/commons/plugin/real.check.js';
import './js/commons/plugin/dynamic.allow.blank.js';
import './js/commons/plugin/field.hideable.js';
import './js/commons/plugin/form.persistable.js';
import './js/commons/plugin/form.metadata_driven.js';
import './js/commons/plugin/field.metadata_driven.js';
// application -->
import './js/commons/app.js';
import './js/commons/config.js';
import './js/commons/localization.js';
import './js/commons/localization-descriptor.js';
// data stores -->
import './js/commons/data/jsonreader.js';
import './js/commons/data/record.js';
import './js/commons/data/simplerecord.js';
import './js/commons/data/store.js';
import './js/commons/data/egridstore.js';
import './js/commons/data/listfieldrecord.js';
import './js/commons/data/listdatefieldrecord.js';
import './js/commons/data/country.js';
import './js/commons/data/state.js';
import './js/commons/data/mapprovider.js';
import './js/commons/data/region.js';
import './js/commons/data/geopoint.js';
import './js/commons/data/auditdata.js';
import './js/commons/data/metadata.js';
import './js/commons/data/bufferedstore.js';
// components -->
import './js/commons/comp/accordionlayout.js';
import './js/commons/comp/formlayout.js';
import './js/commons/comp/applet.js';
import './js/commons/comp/buttoncolumn.js';
import './js/commons/comp/checkallcolumn.js';
import './js/commons/comp/listfield.js';
import './js/commons/comp/linkedcombobox.js';
import './js/commons/comp/linkedboxselect.js';
import './js/commons/comp/htmlformfield.js';
import './js/commons/comp/contactdetailslist.js';
import './js/commons/comp/accounthostslist.js';
import './js/commons/comp/keyvaluelist.js';
import './js/commons/comp/pagingtoolbar.js';
import './js/commons/comp/editingtoolbar.js';
import './js/commons/comp/countryselectcombo.js';
import './js/commons/comp/groupingview.js';
import './js/commons/comp/image.js';
import './js/commons/comp/showonmapcolumn.js';
import './js/commons/comp/singlerowselectionmodel.js';
import './js/commons/comp/linkedlovcombo.js';
import './js/commons/comp/linkedlovcombo_improved.js';
import './js/commons/comp/stateselectcombo.js';
import './js/commons/comp/toolbar.js';
import './js/commons/comp/fieldgroup.js';
import './js/commons/comp/checkboxedfield.js';
import './js/commons/comp/geocombobox.js';
import './js/commons/comp/editedtextarea.js';
import './js/commons/comp/form.js';
import './js/commons/comp/old-form.js';
import './js/commons/comp/xform.js';
import './js/commons/comp/geotextfield.js';
import './js/commons/comp/periodfield.js';
import './js/commons/comp/periodfieldwithms.js';
import './js/commons/comp/weekfield.js';
import './js/commons/comp/mapIFrameComponent.js';
import './js/commons/comp/mapComponent.js';
import './js/commons/comp/mapselectcombo.js';
import './js/commons/comp/swf.js';
import './js/commons/comp/loginform.js';
import './js/commons/comp/nonvisual.js';
import './js/commons/comp/drawcircle.js';
import './js/commons/comp/bufferedview.js';
import './js/commons/comp/metadata_field.js';
import './js/commons/comp/formfieldsrow.js';
import './js/commons/comp/periodfieldwithms.js';
import './js/commons/comp/meta_elements/meta.builder.js';
import './js/commons/comp/meta_elements/meta.checkbox.js';
import './js/commons/comp/meta_elements/meta.combobox.js';
import './js/commons/comp/meta_elements/meta.datepicker.js';
import './js/commons/comp/meta_elements/meta.spinner.js';
import './js/commons/comp/meta_elements/meta.textfield.js';

// widgets -->
import './js/commons/app/widget/audit.js';
import './js/commons/app/widget/editpanel.js';
import './js/commons/app/widget/expandablegridpanel.js';
import './js/commons/app/widget/dispatchsheetpanel.js';
import './js/commons/app/widget/usersinfoform.js';
import './js/commons/app/widget/windowform.js';
import './js/commons/app/widget/xformwindow.js';
import './js/commons/app/widget/windowrecordform.js';
import './js/commons/app/widget/helpform.js';
import './js/commons/app/widget/swf/SWFObject.js';
import './js/commons/app/widget/mapwindow.js';
import './js/commons/app/widget/georegionwindow.js';
import './js/commons/app/widget/polygonwindow.js';
import './js/commons/app/widget/userseditform.js';
import './js/commons/app/widget/usersrolecontrol.js';
import './js/commons/app/widget/eventmanager.js';
import './js/commons/app/widget/uploadfile.js';
import './js/commons/app/widget/updatestyle.js';
import './js/commons/app/widget/propertiesform.js';
import './js/commons/app/widget/hue-picker.js';
import './js/commons/app/widget/limitation.js';
// server events -->
import './js/commons/app/widget/coreeventsmanager.js';
// provider -->
import './js/commons/state/gridcookieprovider.js';
// fixes -->
import './js/ext-fixes.js';

// VTypes -->
import './js/commons/vtypes/decimal-number-vtype.js';
import './js/commons/vtypes/email-address-vtype.js';
//
import './mxbt.js';
